// extracted by mini-css-extract-plugin
export default {"modalBody":"SupportModal_modalBody__jgm5+"};